/*
 * Copyright (c) 2026. Tooling Team
 */

// Shared by the standalone Code Evidence page and the inline expanded-row panel
// so both build their DataTable columns/rows identically.

export const LAB_DOMAIN_EVIDENCE_ROW_ID = "__labDomainEvidenceRowId";

export const formatColumnHeader = (key) =>
  String(key)
    .replace(/([a-z0-9])([A-Z])/g, "$1_$2")
    .split("_")
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");

export const formatCellValue = (value) => {
  if (value === null || value === undefined) {
    return "";
  }

  if (Array.isArray(value)) {
    return value.map(formatCellValue).join(", ");
  }

  if (typeof value === "object") {
    return JSON.stringify(value);
  }

  return String(value);
};

export const getColumnKeys = (rows) => [
  ...new Set(rows.flatMap((row) => Object.keys(row || {}))),
];

const getEvidenceRowId = (row, index) =>
  String(row?._id ?? row?.id ?? row?.evidenceId ?? index);

export const getRowsWithInternalIds = (rows) =>
  rows.map((row, index) => ({
    ...row,
    [LAB_DOMAIN_EVIDENCE_ROW_ID]: getEvidenceRowId(row, index),
  }));

export const getEvidenceColumns = (rows) => {
  if (!rows.length) {
    return [];
  }

  return getColumnKeys(rows)
    .filter((key) => key !== LAB_DOMAIN_EVIDENCE_ROW_ID)
    .map((key) => ({
      header: formatColumnHeader(key),
      accessorKey: key,
      cell: (cell) => formatCellValue(cell.getValue()),
    }));
};
